module.exports = __webpack_public_path__ + "media/images/sk100-046add865205be454e350102dc3179a3.svg";